<template>
  <nav class="project-nav">
    <div class="container" v-if="this.$parent.getTitle() !== 'RECUR'">
      <div class="prev">
        <a v-on:click="prev($event)">
          <img src="../assets/common/angle-left.svg" alt="Previous Project" />
          <span>Previous Project</span>
        </a>
      </div>
      <div class="next">
        <a v-on:click="next($event)">
          <span>Next Project</span>
          <img src="../assets/common/angle-right.svg" alt="Next Project" />
        </a>
      </div>
    </div>
    <div class="container" v-if="this.$parent.getTitle() === 'RECUR'">
      <div>
        <router-link to="/" class="btn btn--small btn--dark">
          <span>Home</span>
        </router-link>
      </div>
      <!-- <div>
        <a
          href="https://projects.invisionapp.com/prototype/RECUR-Animated-Prototype-ck8jngabf0017pc01yixffxwq/play/69123471"
          class="btn btn--small btn--tertiary"
          target="_blank"
          >View Prototype</a
        >
      </div> -->
      <div>
        <router-link to="/project/grubhub" class="btn btn--small">
          <span>View Professional Work</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ProjectNav',
  methods: {
    next: function(e) {
      this.$parent.next(e);
    },
    prev: function(e) {
      this.$parent.prev(e);
    }
  }
};
</script>
